import { useState, useCallback, memo } from 'react';

const menuData = {
  brand: { title: '브랜드', items: [
    { name: '회사소개', href: '/about' },
    // { name: '가맹문의', href: '/franchise' }
  ]},
  product: { title: '제품', items: [
    { name: '골드바', href: '/products?category=goldBars' },
    { name: '실버바', href: '/products?category=silverBars' },
    { name: '골드 주얼리', href: '/products?category=jewelry' },
    { name: '행운의 열쇠', href: '/products?category=luckyKeys' },
    { name: '동물', href: '/products?category=animals' },
  ]},
  price: { title: '시세', items: [
    { name: '금/은 시세', href: '/market-price' }
  ]},
  // store: { title: '매장', items: [
  //   { name: '지점찾기', href: '/store-locator' }
  // ]}
};

const MegaMenu = memo(({ activeMenu, onMenuChange, onLeave }) => (
  <div className="mega-menu" onMouseLeave={onLeave} data-active={activeMenu}>
    <div className="mega-menu__content">
      <div className="mega-menu__grid">
        {Object.entries(menuData).map(([key, menu]) => (
          <div key={key} 
               className={`mega-menu__column ${activeMenu === key ? 'active' : ''}`}
               onMouseEnter={() => onMenuChange(key)}>
            <h3 className="mega-menu__title">{menu.title}</h3>
            <ul className="mega-menu__links">
              {menu.items.map((item, idx) => (
                <li key={idx}><a href={item.href}>{item.name}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
));

const Header = ({ scrolled }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(null);

  const handleMenuEnter = useCallback((menu) => setActiveMenu(menu), []);
  const handleMenuLeave = useCallback(() => setActiveMenu(null), []);
  const toggleMobile = useCallback((key) => setMobileOpen(prev => prev === key ? null : key), []);
  const closeMobile = useCallback(() => setMobileOpen(null), []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${activeMenu ? 'menu-open' : ''}`}>
      <div className="header__container">
        <div className="header__content">
          <div className="header__logo">
            <a href="/" className="logo">
              <img src="/images/logo.png" alt="한국국민금거래소" />
            </a>
          </div>
          
          <nav className="header__nav">
            <ul className="nav" role="menubar">
              {Object.entries(menuData).map(([key, menu]) => (
                <li key={key} className="nav__item" role="none" onMouseEnter={() => handleMenuEnter(key)}>
                  <a href={key === 'product' ? '/products' : (menu.items[0]?.href || `/${key}`)} 
                     className={`nav__link ${activeMenu === key ? 'active' : ''}`}
                     role="menuitem"
                     aria-haspopup="true"
                     aria-expanded={activeMenu === key}>
                    {menu.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          
          <button className="header__mobile-btn" 
                  onClick={() => setMobileOpen(prev => prev ? null : 'menu')}
                  aria-label="메뉴 열기"
                  aria-expanded={!!mobileOpen}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>

      <MegaMenu activeMenu={activeMenu} onMenuChange={handleMenuEnter} onLeave={handleMenuLeave} />

      <div className="mobile-menu" data-open={!!mobileOpen}>
        <ul className="mobile-menu__list">
          {Object.entries(menuData).map(([key, menu]) => (
            <li key={key} className={`mobile-menu__item ${mobileOpen === key ? 'open' : ''}`}>
              <button className="mobile-menu__main" onClick={() => toggleMobile(key)} aria-expanded={mobileOpen === key}>
                <span>{menu.title}</span>
                <span className="mobile-menu__arrow">▼</span>
              </button>
              <ul className="mobile-menu__submenu">
                {menu.items.map((item, idx) => (
                  <li key={idx}>
                    <a href={item.href} onClick={closeMobile}>{item.name}</a>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;